window.cart = {};

import { priceStatus } from './hide_prices.js';

let _loading_popup = false;

export function setLoadingPopup(value) {
    _loading_popup = value;
}

export function getLoadingPopup() {
    return _loading_popup;
}

function handle_price(num) {
    return parseFloat(num).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export async function handle_popup(id) {
    const popup = document.querySelector('#cart-popup');
    const content = document.querySelector('#cart-popup-content');
    let tempCart = {};

    setLoadingPopup(true);
    try {
        const response = await fetch(`/api/publication?id=${id}`);
        const data = await response.json();

        const hasPrices = !!data.products[0];
        const prices = hasPrices
            ? [
                  handle_price(data.products[0].priceDiscount),
                  handle_price(data.products[0].priceList),
                  handle_price(data.products[0].pricePublicDiscount * 1.21),
                  handle_price(data.products[0].pricePublic * 1.21),
              ]
            : [0, 0, 0, 0];

        let current = 0;
        const images = [data.image1, data.image2, data.image3, data.image4, data.image5];

        function getContent() {
            const _content = `
            <div class="closed__pop" id="close__popup"><i class="fa-solid fa-xmark"></i></div>
            <div class="popup_content">
                <div class="data-left">
                    <div class="images">
                        ${images.map((img, i) => `
                            <img class="image ${i === current ? 'current' : ''}" 
                                src="https://servi-compras.com.ar/uploads/${img}" 
                                onerror="this.src='/img/noImage.jpg'"/>
                        `).join('')}
                        <div class="indicator">
                            ${images.map((_, i) => `<span class="dot ${i === current ? 'active' : ''}"></span>`).join('')}
                        </div>
                    </div>
                </div>
                <div class="data-right">
                    <p class="popup__title">${data.title}</p>
                    <p class="sku">SKU: ${data.code}</p>
                    ${
                        isUserLoggedIn
                            ? `
                            <div class="pop__prices" data-name="list__prices">
                                <p> P. lista (sin IVA) </p>
                                ${prices[1] !== prices[0] ? `<p class="line">$ ${prices[1]}</p>` : ''}
                                <p>$ ${prices[0]}</p>
                            </div>
                            <div class="pop__prices">
                                <p> PVP (IVA incluido) </p>
                                ${prices[3] !== prices[2] ? `<p class="line">$ ${prices[3]}</p>` : ''}
                                <p>$ ${prices[2]}</p>
                            </div>
                            `
                            : ''
                    }
                    ${
                        isUserLoggedIn
                            ? `<p class="talles__select">Selecciona el Talle</p>
                            <div class="add_talles">
                                <div class="talles">
                                    <div class="opciones">
                                        <div id="sizes-container" class="sizes"></div>
                                    </div>
                                </div>
                                <div class="add_btn">
                                    <button id="send" class="subcarrito">Añadir al carrito</button>
                                </div>
                            </div>`
                            : ''
                    }
                </div>
            </div>
            `;

            content.innerHTML = _content;

            const talles = popup.querySelector('#sizes-container');
            const close = popup.querySelector('#close__popup')

            if (close) {
                close.addEventListener('click', () => {
                popup.style.display = 'none'
                })
            }

            if (talles) {
                data.products.forEach((product) => {
                     if (product.stock <= 0) return;

                    const talle_container = document.createElement('div');
                    const btn_talle = document.createElement('button');
                    const btn_minus = document.createElement('button');
                    const btn_plus = document.createElement('button');
                    const input = document.createElement('input');


                    talle_container.className = 'talle__container';
                    btn_talle.className = 'size__btn';
                    btn_minus.className = 'minus';
                    btn_plus.className = 'plus';
                    input.className = 'campos';

                    input.placeholder = '0';
                    input.style.outline = 'none';
                    input.disabled = product.stock <= 0;
                    
                    btn_talle.innerText = product.size;
                    btn_minus.innerHTML = `<i class="fa fa-minus"></i>`;
                    btn_plus.innerHTML = `<i class="fa fa-plus"></i>`;
                    
                    const message = document.createElement('span');
                     message.className = 'stock-message';
                     message.style.color = 'red';
                     message.style.fontSize = '12px';
                     message.style.marginLeft = '5px';
                     message.style.display = 'none'; // oculto por defecto
                     talle_container.appendChild(message);

                    talle_container.appendChild(btn_talle);
                     talle_container.appendChild(btn_minus);
                     talle_container.appendChild(input);
                     talle_container.appendChild(btn_plus);
                     talle_container.appendChild(message);
                     talles.appendChild(talle_container);

                     // Función para actualizar tempCart
                     function updateTempCart() {
                        const cantidad = parseInt(input.value, 10) || 0;
                        tempCart[product.size] = {
                           input,
                           stock: product.stock,
                           cantidad,
                           size: product.size,
                           code: product.code,
                           id: product.id
                        };
                     }

                     // Evento input
                     input.addEventListener('input', () => {
                        let val = parseInt(input.value, 10) || 0;

                        if (val > product.stock) {
                           message.style.display = 'inline';
                           message.innerText = '¡No hay stock disponible!';
                           input.value = product.stock;
                        } else {
                           message.style.display = 'none';
                           input.value = val;
                        }

                        updateTempCart();
                     });

                     // Botón +
                     btn_plus.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (input.disabled) return;
                        let val = parseInt(input.value, 10) || 0;
                        if (val < product.stock) {
                           input.value = val + 1;
                           message.style.display = 'none';
                        } else {
                           message.style.display = 'inline';
                           message.innerText = '¡No hay stock disponible!';
                        }
                        updateTempCart();
                     });

                     // Botón -
                     btn_minus.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (input.disabled) return;
                        let val = parseInt(input.value, 10) || 0;
                        if (val > 0) {
                           input.value = val - 1;
                           message.style.display = 'none';
                        }
                        updateTempCart();
                     });
                });

                // Click en Añadir al carrito
                popup.querySelector('#send').addEventListener('click', () => {
                    addItemFromPopup(tempCart);
                });
            }

            // Dots de imágenes
            const dots = content.querySelectorAll('.dot');
            dots.forEach((dot, i) => {
                dot.addEventListener('click', () => {
                    if (dot.classList.contains('active')) return;
                    current = i;
                    getContent();
                });
            });
        }

        getContent();
        popup.style.display = 'grid';
        priceStatus();
        setLoadingPopup(false);
    } catch (e) {
        //console.error(e);
        setLoadingPopup(false);
    }
}

// Función global para enviar productos del popup al carrito
window.addItemFromPopup = function(tempCart) {
    const productos = Object.values(tempCart)
        .filter(item => item.cantidad > 0)
        .map(item => ({
            id: item.id,
            quantity: item.cantidad,
            code: item.code,
            stock: item.stock
        }));

    /*if (!productos.length) {
        console.error('[CARRITO][POPUP] No hay productos con cantidad > 0');
        return;
    }*/

    // console.log('[CARRITO][POPUP] Productos a enviar:', productos);
    sendProductsToCart(productos);
    document.querySelector('#cart-popup').style.display = 'none';
};
